import React from "react";
import {Link} from "react-router-dom";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import UrlDecorator from "../../utils/UrlDecorator";
import FavouriteList from "./FavouriteList";
import HomeNewsletter from "../HomePage/HomeNewsletter";
import removeIcon from "../../assets/images/icons/close.svg";

function FavouritesVehiclePage() {

    MetaTagsManipulator.setTitle("Ulubione");
    MetaTagsManipulator.setDescription("Ulubione");

    UrlDecorator.addSellerCode();

    const deleteAllFavouritesHandler = () => {
        localStorage.setItem('favouriteVehicles', JSON.stringify([]));
        window.location.href = "ulubione";
    };

    return (
        <div className="lista-ofert favourites-page">

            <div className="container favourites-header">
                <div className="favourites-breadcrumb">
                    <Link to="/">go-auto.pl</Link>
                    <span className="favourites-breadcrumb-sep">›</span>
                    <span>Ulubione auta</span>
                </div>
                <div className="favourites-heading-row">
                    <h1 className="favourites-title">Ulubione auta</h1>
                    <button type="button" className="favourites-remove-all" onClick={deleteAllFavouritesHandler}>
                        usuń wszystkie
                        <img src={removeIcon} alt="" className="favourites-remove-all-icon"/>
                    </button>
                </div>
            </div>

            <FavouriteList viewType="grid-view"/>

            <HomeNewsletter/>
        </div>
    );
}

export default FavouritesVehiclePage;
